import returnUrlParams from "./returnUrlParams";

export default function addUrlParams(url, obj) {
  let newUrl = url;

  if (typeof url === 'string') {
    newUrl += `${ url.includes('?') ? '&' : '?' }${ returnUrlParams(obj) }`;
  }

  return newUrl;
}
